import api from 'service/api'

const dponetAPI = api.create('dponet')

const create = async ({ daiFeedback }) => {
  return await dponetAPI.post('/dai_feedbacks', { daiFeedback })
}

export default {
  create,
}
